import { UserProfileResolver } from './user-profile.resolver';
import { Routes } from '@angular/router';
import { HOLD_APP_SPLASH } from '@core-session';

export const routes: Routes = [
  {
    path: 'authorization/callback',
    loadComponent: () => import('@feature-auth').then((m) => m.AuthCallbackComponent),
    data: { [HOLD_APP_SPLASH]: true },
  },
  {
    path: 'authorization',
    loadChildren: () => import('@feature-auth').then((m) => m.authContainerPageRoutes),
  },
  {
    path: 'carrier-registration',
    loadChildren: () =>
      import('@feature-carrier-registration').then((m) => m.carrierRegistrationRoutes),
    resolve: {
      cabinetAccess: UserProfileResolver,
    },
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.routes').then((m) => m.dashboardRoutes),
  },
  {
    path: 'magic-link',
    loadChildren: () => import('@feature-magic-links').then((m) => m.magicLinksRoutes),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];
